import { render, staticRenderFns } from "./CompaniesWps.vue?vue&type=template&id=17c5cd72&scoped=true"
import script from "./CompaniesWps.vue?vue&type=script&lang=js"
export * from "./CompaniesWps.vue?vue&type=script&lang=js"
import style0 from "./CompaniesWps.vue?vue&type=style&index=0&id=17c5cd72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c5cd72",
  null
  
)

export default component.exports